import iframeResize from '@iframe-resizer/parent';

import type { InitSchema, LoadSchema } from './lib/sdk-types';
import { InitConfig, LoadConfig } from './lib/sdk-types';
import { embeddedAPI } from './lib/utils/embeddedApi';
import { createLoadingIndicator } from './lib/utils/loading';
import { getIframeUrl } from './lib/utils/url';
import metadata from './metadata.json';

// Business Licence for Iframe Resizer (public facing key)
const iframeResizerLicenceKey = '12ajjdewwwy-19f03yll923-12fa3gxfvgg';

window.Spade = {
  init(schema: InitSchema) {
    const initConfig = InitConfig.parse(schema);
    const handleUnload = () => embeddedAPI.destroy?.();
    window.addEventListener('beforeunload', handleUnload);

    return {
      async load(loadSchema: LoadSchema) {
        const loadConfig = LoadConfig.parse(loadSchema);
        const element = document.querySelector(loadConfig.element);

        if (!element || !(element instanceof HTMLElement)) {
          throw new Error(`Could not find a HTML element with selector "${loadConfig.element}"`);
        }

        element.style.position = 'relative';

        const loadingIndicator = createLoadingIndicator(loadConfig.themeVariant);
        const iframeId = `spade-${loadConfig.view}`;

        const iframe = document.createElement('iframe');
        element.replaceChildren(loadingIndicator, iframe);
        const iframeUrl = getIframeUrl({
          locale: initConfig.locale,
          view: loadConfig.view,
          path: loadConfig.path,
          themeVariant: loadConfig.themeVariant
        });

        iframe.src = iframeUrl;
        iframe.style.width = '100%';
        iframe.style.border = 'none';
        iframe.style.display = 'block';
        iframe.dataset.testid = iframeId;
        iframe.hidden = true;

        iframe.onload = () => {
          // Fade out the loader smoothly before removing it
          if (loadingIndicator && loadingIndicator.style) {
            loadingIndicator.style.opacity = '0';
            setTimeout(() => {
              if (element.contains(loadingIndicator)) {
                element.removeChild(loadingIndicator);
              }
            }, 300); // Match the CSS transition duration
          }
          iframe.hidden = false;
        };

        embeddedAPI.registerIframe(iframeId, iframe, new URL(iframeUrl).origin);

        element.appendChild(iframe);
        iframeResize({ license: iframeResizerLicenceKey, waitForLoad: true }, iframe);

        return {
          unload: () => {
            // Clean up any remaining loader
            const remainingLoader = element.querySelector('.loader-wrapper');
            if (remainingLoader) {
              element.removeChild(remainingLoader);
            }
            embeddedAPI.unregisterIframe(iframeId);
          }
        };
      }
    };
  },
  version: metadata.version,
  api: embeddedAPI
};
